<style>
.van-popup.van-toast {
  background: var(--van-toast-background) !important;
  box-sizing: content-box !important;
  transition: all var(--van-duration-fast) !important;
  width: 200px !important;
  max-width: 400px !important;
}

/* input::placeholder{
  font-size: 18px !important;
  font-family: 'PingFang SC' !important;
  opacity: 0.8 !important;
} */
/* 二倍 */
input::placeholder {
  font-size: 36px !important;
  font-family: 'PingFang SC' !important;
  opacity: 0.8 !important;
}
</style>
<template>
  <Nav v-if="!route.meta.hideNav" :theme="theme" :showTips="showTips" @connectWallet="init" />
  <NetworkErr @confirm="init" ref="networkErrRef" />
  <Notice ref="noticeRef" />
  <div id="main">
    <router-view></router-view>
  </div>
  <TabBar v-show="showTabBar" />
  <!-- <van-popup v-model:show="show" position="bottom" round closeable @close="() => { }" safe-area-inset-bottom>
    <div class="pt-[18px] pb-[20px] px-10px">
      <div class="mb-20 text-[18px] font-pingfang font-700">邀请码</div>
      <div class="bg-[#F2F6F6] px-14 py-20 rounded-[8px] mb-20">
        <input type="text" v-model="invitationCode" class="outline-none border-none bg-[#fff]/0 color-[#000]/80 font-pingfang text-[18px]"
          placeholder="请输入邀请码" />
      </div>
      <div
      @click="handleConfirmCode"
      :class="invitationCode ? 'opacity-100' : 'opacity-50'"
        class="van-haptics-feedback disabled:opacity-50 py-16 text-[16px] font-roboto bg-[#000] text-[#fff] rounded-[2px] flex items-center justify-center">
        确 定</div>
    </div>
  </van-popup> -->
  <van-popup v-model:show="show" position="bottom" round closeable @close="() => { }" safe-area-inset-bottom>
    <div class="pt-[40px] pb-[20px] px-20px">
      <div class="text-[36px] font-pingfang font-700">{{ $t('common.invitationCode') }}</div>
      <div class="bg-[#F2F6F6] px-14 py-20 rounded-[8px] mt-40px">
        <input type="text" v-model="invitationCode"
          class="outline-none border-none bg-[#fff]/0 color-[#000]/80 font-pingfang text-[36px]"
          :placeholder="$t('common.enterInvitationCode')" />
      </div>
      <div @click="handleConfirmCode" :class="invitationCode ? 'opacity-100' : 'opacity-50'"
        class="mt-40px van-haptics-feedback disabled:opacity-50 py-16 text-[32px] font-roboto bg-[#000] text-[#fff] rounded-[2px] flex items-center justify-center">
        {{ $t('common.confirm') }}
      </div>
    </div>
  </van-popup>
</template>

<script setup>
import Nav from '@/components/header.vue'
import NetworkErr from '@/components/networkErr2x.vue'
import TabBar from '@/components/tabBar.vue'
import { watch, ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import useWeb3 from '@/utils/useWeb3'
import { showToast } from 'vant'
import { useIndexStore } from '@/store'
import api from '@/apis'
import config from '@/config'
import Notice from '@/components/notice.vue'
const show = ref(false)
const store = useIndexStore()
const route = useRoute()
const theme = ref('') // dark light
let showTips = ref(true)
let invitationCode = ref('')
const showTabBar = computed(() => !route.meta.hideTabBar)
//监听地址变化
useWeb3.onAccountChange((address) => {
  store.setToken('')
  setTimeout(() => {
    window.location.reload()
  }, 800)
})

let networkErrRef = ref(null)
let noticeRef = ref(null)
let handleConfirmCode = async () => {
  if (!invitationCode.value) {
    return
  }
  show.value = false
  login()
}

const init = async () => {
  try {
    await useWeb3.ensureReady()
    // if (window.ethereum.chainId != config.network.chainId) {
    //   networkErrRef.value.open()
    //   return
    // }
    // let address = config.address || useWeb3.signer?.address
    // const isRegister = await api.home.isRegister({ address })
    // if (!isRegister?.isRegister) {
    //   invitationCode.value = store.userInfo?.invitationCode || getInvitationCodeFromUrl() || ''
    //   if (config.env == 'dev' && invitationCode.value == '') {
    //     invitationCode.value = config.debugCode
    //   }
    //   show.value = true
    //   return
    // }
    login()
  } catch (error) {
    console.log('[  ] >', error)
  }
}

let login = async () => {
  await useWeb3.ensureReady()
  let address = config.address || useWeb3.signer?.address
  // const { message } = await api.home.loginMessage()
  const message = 'welcome to ASALI, pls sign this message to login!'
  const signature = await useWeb3.signMessage(`${message}`)
  const res = await api.address.login({
    address: address,
    sign: signature
  })
  const jwt = typeof res === 'string' ? res : res?.token || ''
  store.setAddress(address)
  store.setToken(jwt)
  await store.getUserInfo()
  if (config.isNotice) {
    noticeRef.value.open()
  }
}

useWeb3.onChainChange((chainId) => {
  if (window.ethereum.chainId != config.network.chainId) {
    networkErrRef.value.open()
    return
  }
})
onMounted(() => {
  if (config.isVerifyToken) {
  init()
  }
  if (store.token) {
    store.getUserInfo()
  }
})
//监听路由变化
watch(
  () => route.path,
  (val) => {
    theme.value = route.meta.headerTheme || 'light'
    showTips.value = route.meta.showTips
  }
)

</script>
